import React, { useEffect } from 'react'
import PostCard from '../components/PostCard';
import { getPost } from '../redux/actions/post';
import { useDispatch, useSelector } from 'react-redux';
import MainLayout from '../layouts/MainLayout';
import { Breadcrumb, Spin } from 'antd';
import { getCategories } from '../redux/actions/category';
import { Helmet } from 'react-helmet-async';

export const Posts = () => {
    const { posts } = useSelector((state: any) => state.posts);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch<any>(getPost());
        dispatch<any>(getCategories());
    }, []);

    const breadcrumbItems = [
        {
            title: 'Anasayfa',
            href: '/',
        },
        {
            title: 'Blog',
            href: '/blog',
        },
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Blog | Sakarya Lastik</title>
                <meta name="description" content="Blog sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta name="keywords" content="blog, blog sayfası, blog yazıları" />
                <meta property="og:title" content="Blog | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta property="og:description" content="Blog sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className='flex w-full bg-gray-50 p-3 border rounded-md'>
                <Breadcrumb items={breadcrumbItems} />
            </div>
            <div className='container mx-auto'>
                <h1 className='text-2xl font-bold my-5'>Blog</h1>
                <div className='flex flex-wrap gap-3'>
                {posts.length > 0 ? posts?.map((post) => (
                    <PostCard key={post._id} post={post} />
                    )) : <Spin />}
                </div>
            </div>
        </MainLayout>
    )
}

export default Posts;
